import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import { GetToken } from "../../../../../actions/userAction.js";
import { useDispatch, useSelector } from "react-redux";
import "./CreateArticle.css";

// components
import FormField from "../../../Components/FormField/FormField";

export default function CreateArticle() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selector = useSelector((state) => state);
  //const [id, setId] = useState("");
  const [textareadata, settextdata] = useState({
    value: RichTextEditor.createEmptyValue(),
  });
  const [filetoken, setfiletoken] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    rawimage: [],
    image: "",
    description: "",
    RechtextforDescription: RichTextEditor.createEmptyValue(),
    author: "",
    time: "",
    date: "",
  });
  const [show, setshow] = useState(false);

  console.log(formData);
  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    try {
      if (formData?.rawimage?.length !== 0) {
        const form = new FormData();
        form.append("file", formData?.rawimage);
        await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
          method: "POST",
          headers: {
            Authorization: `Bearer  ${filetoken}`,
          },
          body: form,
        })
          .then((res) => res.json())
          .then(async (data) => {
            const input = {
              profile_image: data.source_url,
            };
            //send image url to backend

            let mainData = {
              title: formData?.title,
              rawimage: formData?.rawimage,
              image: data.source_url,
              description: formData?.description,
              RechtextforDescription: formData?.RechtextforDescription,
              author: formData?.author,
              time: formData?.time,
              date: formData?.date,
            };

            try {
              let res = null;
              let token = JSON.parse(localStorage.getItem("token"));

              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token,
                },
              };
              if (id) {
                res = await api.put(`/article-admin/${id}`, mainData, config);
              } else {
                res = await api.post("/article-admin/", mainData, config);
              }
              const data = res.data.data;
              if (data) {
                // landmark created - redirect to landmark list
                navigate("/admin/article-table");
              } else {
                // show error
              }
            } catch (err) {
              console.error(err.response.data.error);

              swal({
                title: "Error",
                text: err.response.data.error,
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        try {
          let res = null;
          if (id) {
            res = await api.put(`/article-admin/${id}`, formData, config);
          } else {
            res = await api.post("/article-admin/", formData, config);
          }
          const data = res.data.data;
          if (data) {
            // landmark created - redirect to landmark list
            navigate("/admin/article-table");
          } else {
            // show error
          }
        } catch (err) {
          console.error(err.response.data.error);

          swal({
            title: "Error",
            text: err.response.data.error,
            icon: "error",
          });
        }
      }
    } catch (err) {
      console.error(err.response.data.error);

      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
    }

    // const createOrUpdateLandmark = async () => {
    //   try {
    //     let res = null;
    //     if (id) {
    //       res = await api.put(`/article-admin/${id}`, formData, config);
    //     } else {
    //       res = await api.post("/article-admin/", formData, config);
    //     }
    //     const data = res.data.data;
    //     if (data) {
    //       // landmark created - redirect to landmark list
    //       navigate("/admin/article-table");
    //     } else {
    //       // show error
    //     }
    //   } catch (err) {
    //     console.error(err.response.data.error);

    //     swal({
    //       title: "Error",
    //       text: err.response.data.error,
    //       icon: "error",
    //     });
    //   }
    // };
    // createOrUpdateLandmark();
  };

  useEffect(() => {
    let id = params.id;

    const fetchLandmark = async () => {
      let id = params.id;
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const res = await api.get(`/article/${id}`, config);
      const data = res.data.data;
      console.log(data);
      const { title, image, description, time, author, date } = data;

      setFormData({
        title: title,
        description: description,
        image: image,
        date: date,
        RechtextforDescription: RichTextEditor.createValueFromString(
          description,
          "html"
        ),
        time: time,
        author: author,
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        title: "",
        image: "",
        rawimage: [],
        description: "",
        RechtextforDescription: RichTextEditor.createEmptyValue(),
        author: "",
        time: "",
        date: "",
      });
    }
  }, [params]);

  const onChange = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      description: data,
      RechtextforDescription: value,
    });
  };

  const { title, image, description, time, author, date, rawimage } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Title"
            placeholder="Title"
            value={title}
            name="title"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Time</label>
            <input
              type="time"
              placeholder="Time"
              className="userUpdateInput"
              value={formData?.time}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  time: e.target.value,
                });
              }}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Date</label>
            <input
              type="date"
              placeholder="Date"
              className="userUpdateInput"
              value={formData?.date}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  date: e.target.value,
                });
              }}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Description</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.RechtextforDescription}
              onChange={onChange}
            />
          </div>
          {image == "" ? (
            <>
              <div className="userUpdateItem">
                <label className="user__label">Image Link</label>
                <input
                  type="file"
                  placeholder="Image Link"
                  className="userUpdateInput"
                  // value={formData?.rawimage}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      rawimage: e.target.files[0],
                    });
                  }}
                />
              </div>{" "}
            </>
          ) : (
            <>
              {show ? (
                <>
                  <div className="userUpdateItem">
                    <label className="user__label">Image Link</label>
                    <input
                      type="file"
                      placeholder="Image Link"
                      className="userUpdateInput"
                      //value={formData?.rawimage}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          rawimage: e.target.files[0],
                        });
                      }}
                    />
                  </div>{" "}
                </>
              ) : (
                <>
                  <div className="userUpdateItem">
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div>
                        <img
                          src={image}
                          style={{
                            height: "140px",
                            width: "400px",
                          }}
                        />
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            setshow(true);
                          }}
                        >
                          Edit{" "}
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </>
              )}
            </>
          )}
          <div className="userUpdateItem">
            <label className="user__label">Author</label>
            <input
              type="text"
              placeholder="Author"
              className="userUpdateInput"
              value={formData?.author}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  author: e.target.value,
                });
              }}
            />
          </div>

   

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update Article" : "Add Article"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
